<template>
  <div>
    <v-toolbar flat dark class="BackgroundStyle-2">
      <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->

      <v-toolbar-title>MyWalletWatcher</v-toolbar-title>

      <v-spacer></v-spacer>

      
        <v-btn flat @click.prevent="$router.push({ path: '/Login' })">
          Login
        </v-btn>
        <v-btn outline color="orange" @click.prevent="$router.push({ path: '/Registration' })">
          Sign up
        </v-btn>

      

    </v-toolbar>
    <v-container fill-height grid-list-md class="pa-5">
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 text-xs-center>
          <v-layout justify-center align-center>
            <v-flex shrink>
              <img src="../../static/img/icons/android-chrome-192x192.png" alt="Mww Logo" width="100%" class="img-circle" />
          </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md8>

          <div class="pa-1">
            <span class="homeheadline grey--text"> {{ homeheadline }}  </span>
          </div>
          <div class="pa-1">
            <span class="homesubheadline grey--text">{{ homesubheadline }}</span>
          </div>

          <div>
            <v-btn large color="teal">
              get started
            </v-btn>
          </div>          
        </v-flex>
        
      </v-layout>
    </v-container>
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex xs8  sm12 md4 offset-xs2 offset-sm0
                v-for="card in cards"
                :key="card.title"
                >
          <v-card class="elevation-5">
            <v-img :src="card.src"
                   height="200px">
            </v-img>
            <v-card-title > 
              <div class="text-xs-center">
                <div class="headline"> {{ card.title }} </div>
                <span class="grey--text"> {{ card.featureDescription }}</span>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {

    data: () => ({
      
        homeheadline: 'Keep an eye on your wallet.',
        homesubheadline: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit non orci.',
        cards: [
          { title: 'Budgetting', src: '../../static/img/thumbnails/triangle-1280x728.jpg', featureDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit' },
          { title: 'Feature 2', src: '../../static/img/thumbnails/accountant-1280x856.jpg', featureDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit'  },
          { title: 'Feature 3', src: '../../static/img/thumbnails/wallet-1280x833.jpg', featureDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nec dolor et sapien ultrices suscipit suscipit'  }
        ]
      
    })

  }
</script>
<style scoped>
  * {
    font-family: Calibri !important;
  }

  .homeheadline {
    font-size: 48px;
  }

  .homesubheadline {
    font-size: 24px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue